<template>
  <b-modal
    id="milestone-modal"
    centered
    hide-footer
    :title="title"
    @hidden="emitClose"
    :ok-only="false"
  >
    <div class="d-flex flex-column align-items-center text-center">
      <img
        v-if="imageUrl"
        :src="imageUrl"
        alt=""
        style="width:64px;height:64px;object-fit:contain;margin-bottom:12px"
      />
      <h5 class="text-primary mb-2">{{ title }}</h5>
      <p class="text-terciary mb-0" style="white-space:pre-line">{{ body }}</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "MilestoneModal",
  props: {
    milestone: { type: Object, default: null } // { name, message, imageUrl, rewardText? }
  },
  computed: {
    title(){
      const t = (this.milestone && this.milestone.name) || "Milestone"
      return t
    },
    body(){
      const m = (this.milestone && this.milestone.message) || ""
      const r = (this.milestone && this.milestone.rewardText) || ""
      return r ? (m ? m + "\n" + r : r) : m
    },
    imageUrl(){
      return (this.milestone && this.milestone.imageUrl) || ""
    }
  },
  watch: {
    milestone(val){
      if (val) this.$bvModal.show("milestone-modal")
      else this.$bvModal.hide("milestone-modal")
    }
  },
  methods: {
    emitClose(){
      this.$emit("close")
    }
  }
}
</script>

<style scoped>
/* brand polish if desired */
</style>
